import PolicyLayout from '../components/PolicyLayout';

export default function Support() {
  return (
    <PolicyLayout title="Support">

      <h2>Getting Started</h2>
      <p>
        VirtueSign automatically inserts email signatures into Microsoft Outlook when you compose new messages. 
        The signatures are generated from your Microsoft 365 profile information.
      </p>

      <h2>How It Works</h2>
      <ol>
        <li>Your administrator installs VirtueSign for your organization</li>
        <li>The add-in appears in Outlook (desktop, web, and mobile)</li>
        <li>When you compose a new email, your signature is automatically inserted</li>
        <li>You can also manually insert signatures using the ribbon button</li>
      </ol>

      <h2>Supported Platforms</h2>
      <ul>
        <li><strong>Outlook Desktop (Windows/Mac):</strong> Full support with automatic insertion</li>
        <li><strong>Outlook Web (OWA):</strong> Full support in modern browsers</li>
        <li><strong>Outlook Mobile (iOS/Android):</strong> Automatic signature insertion</li>
      </ul>

      <h2>Common Questions</h2>
      
      <h3>Why isn't my signature appearing?</h3>
      <ul>
        <li>Check that VirtueSign is installed and enabled in Outlook</li>
        <li>Verify your administrator has assigned a signature template to you</li>
        <li>Try refreshing Outlook or restarting the application</li>
        <li>Ensure your Microsoft 365 profile is complete</li>
      </ul>

      <h3>Can I customize my signature?</h3>
      <p>
        Signature templates are managed by your organization's administrators to ensure brand consistency. 
        Contact your IT department if you need changes.
      </p>

      <h3>Does VirtueSign work offline?</h3>
      <p>
        VirtueSign requires an internet connection to fetch signatures from the server. 
        Previously cached signatures may work temporarily offline.
      </p>

      <h3>Is my data secure?</h3>
      <p>
        Yes. VirtueSign uses Microsoft 365 authentication and encrypts all sensitive data. 
        See our <a href="/privacy">Privacy Policy</a> for details.
      </p>

      <h2>Administrator Resources</h2>
      <p>
        Administrators can manage users, templates, and assignments through the VirtueSign admin portal at:
        <br />
        <a href="https://sign.virtue.dk">https://sign.virtue.dk</a>
      </p>

      <h2>Technical Support</h2>
      <p>
        For technical issues or questions:
      </p>
      <p>
        <strong>Email:</strong> <a href="mailto:support@virtue.dk">support@virtue.dk</a><br />
        <strong>Response time:</strong> Within 1-2 business days
      </p>

      <h2>Report a Bug</h2>
      <p>
        If you encounter a bug or unexpected behavior, please email us with:
      </p>
      <ul>
        <li>Description of the issue</li>
        <li>Steps to reproduce</li>
        <li>Platform and Outlook version</li>
        <li>Screenshots if applicable</li>
      </ul>

      <h2>Feature Requests</h2>
      <p>
        We welcome feedback! Send feature requests to <a href="mailto:support@virtue.dk">support@virtue.dk</a>
      </p>

      <h2>About Virtue ApS</h2>
      <p>
        VirtueSign is developed by Virtue ApS, a Danish software company specializing in Microsoft 365 solutions.
      </p>
      <p>
        <strong>Website:</strong> <a href="https://virtue.dk">https://virtue.dk</a><br />
        <strong>Email:</strong> <a href="mailto:info@virtue.dk">info@virtue.dk</a>
      </p>
    </PolicyLayout>
  );
}
